// import React, { useState } from "react";
// import { Box } from "@mui/material";
// import { Link } from "react-router-dom";
// import ListItem from "@mui/material/ListItem";
// import List from "@mui/material/List";
// import ListItemText from "@mui/material/ListItemText";
// import Collapse from "@mui/material/Collapse";
// import ExpandLess from "@mui/icons-material/ExpandLess";
// import ExpandMore from "@mui/icons-material/ExpandMore";

// export default function NestedList() {
//   const [openPacker, setOpenPacker] = useState(false);
//   const [openSandScreen, setOpenSandScreen] = useState(false);

//   const handleClick = (item) => {
//     if (item === "PerformancePacker") {
//       setOpenPacker(true);
//       setOpenSandScreen(false);
//     } else if (item === "SandScreen") {
//       setOpenSandScreen(true);
//       setOpenPacker(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         // flexDirection: { xs: "column", sm: "column", md: "row" },
//         // justifyContent:"center",
//         // maxWidth: "100%",
//         // width: { sm: "250px", md: "380px" },
//         // pt: { xs: 4, sm: 12 },
//         // pb: { xs: 8, sm: 16 },
//       }}
//     >
//       <List
//         sx={{
//           maxWidth: "100%",
//           width: { sm: "250px", md: "250px" },
//           bgcolor: "background.paper",
//         }}
//         component="nav"
//         aria-labelledby="nested-list-subheader"
//       >
//         <ListItem
//           component={Link}
//           to="/tool/packer"
//           onClick={() => handleClick("PerformancePacker")}
//         >
//           <ListItemText primary="High Performance Packer" />
//           {openPacker ? <ExpandLess /> : <ExpandMore />}
//         </ListItem>
//         <Collapse in={openPacker } timeout="auto" unmountOnExit>
//           <ListItem component={Link} to="/tool/3"  sx={{ pl: 4 }}>
//             <ListItemText primary="Swellable Packer" />
//           </ListItem>
//         </Collapse>
//         <Collapse in={openPacker} timeout="auto" unmountOnExit>
//           <ListItem component={Link} to="/tool/2" sx={{ pl: 4 }}>
//             <ListItemText primary="HR Packer" />
//           </ListItem>
//         </Collapse>

//         <Collapse in={openPacker} timeout="auto" unmountOnExit>
//           <ListItem component={Link} to="/tool/1" sx={{ pl: 4 }}>
//             <ListItemText primary="IP Isolation Packer" />
//           </ListItem>
//         </Collapse>

//         <ListItem
//           component={Link}
//           to="/tool/screen"
//           onClick={() => handleClick("SandScreen")}
//         >
//           <ListItemText primary="High quality sand control screen" />
//           {openSandScreen ? <ExpandLess /> : <ExpandMore />}
//         </ListItem>
//         <Collapse in={openSandScreen} timeout="auto" unmountOnExit>
//           <ListItem component={Link} to="/tool/9" sx={{ pl: 4 }}>
//             <ListItemText primary="JM Premium Screen" />
//           </ListItem>
//         </Collapse>

//       </List>

//     </Box>
//   );
// }

// import React, { useState, useEffect } from "react";
// import { Box } from "@mui/material";
// import { Link, useLocation } from "react-router-dom";
// import ListItem from "@mui/material/ListItem";
// import List from "@mui/material/List";
// import ListItemText from "@mui/material/ListItemText";
// import Collapse from "@mui/material/Collapse";
// import ExpandLess from "@mui/icons-material/ExpandLess";
// import ExpandMore from "@mui/icons-material/ExpandMore";

// export default function NestedList() {
//   const [openPacker, setOpenPacker] = useState(false);
//   const [openSandScreen, setOpenSandScreen] = useState(false);
//   const location = useLocation();

//   useEffect(() => {
//     // Define the range of IDs for the packer and sand screen routes
//     const packerIdRange = [1,2,3,4,5,6,7,8];
//     const sandScreenIdRange = [9,10,11];

//     // Extract the ID from the current location pathname
//     const id = parseInt(location.pathname.split("/").pop(), 10);

//     // Check if the ID falls within the packer or sand screen range
//     const isOpenPacker = packerIdRange.includes(id);
//     const isOpenSandScreen = sandScreenIdRange.includes(id);

//     // Set the state based on the ID range
//     setOpenPacker(isOpenPacker);
//     setOpenSandScreen(isOpenSandScreen);
//   }, [location]);

//   return (
//     <Box sx={{ display: "flex" }}>
//       <List
//         sx={{
//           maxWidth: "100%",
//           width: { sm: "250px", md: "250px" },
//           bgcolor: "background.paper",
//         }}
//         component="nav"
//         aria-labelledby="nested-list-subheader"
//       >
//         <ListItem
//           component={Link}
//           to="/tool/packer"
//           onClick={() => setOpenPacker(!openPacker)}
//         >
//           <ListItemText primary="High Performance Packer" />
//           {openPacker ? <ExpandLess /> : <ExpandMore />}
//         </ListItem>
//         <Collapse in={openPacker} timeout="auto" unmountOnExit>
//           <ListItem component={Link} to="/tool/3" sx={{ pl: 4 }}>
//             <ListItemText primary="Swellable Packer" />
//           </ListItem>
//           <ListItem component={Link} to="/tool/2" sx={{ pl: 4 }}>
//             <ListItemText primary="HR Packer" />
//           </ListItem>
//           <ListItem component={Link} to="/tool/1" sx={{ pl: 4 }}>
//             <ListItemText primary="IP Isolation Packer" />
//           </ListItem>
//         </Collapse>

//         <ListItem
//           component={Link}
//           to="/tool/screen"
//           onClick={() => setOpenSandScreen(!openSandScreen)}
//         >
//           <ListItemText primary="High quality sand control screen" />
//           {openSandScreen ? <ExpandLess /> : <ExpandMore />}
//         </ListItem>
//         <Collapse in={openSandScreen} timeout="auto" unmountOnExit>
//           <ListItem component={Link} to="/tool/9" sx={{ pl: 4 }}>
//             <ListItemText primary="JM Premium Screen" />
//           </ListItem>
//         </Collapse>
//       </List>
//     </Box>
//   );
// }

import React, { useState, useEffect } from "react";
import { Box, ButtonBase } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

export default function NestedList() {
  const [openPacker, setOpenPacker] = useState(false);
  const [openSandScreen, setOpenSandScreen] = useState(false);
  const [isPackerClicked, setIsPackerClicked] = useState(false);
  const [isSandScreenClicked, setIsSandScreenClicked] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  //useEffect(() => {
  // Define the range of IDs for the packer and sand screen routes
  // const packerIdRange = [1, 2, 3, 4, 5, 6, 7, 8];
  // const sandScreenIdRange = [9, 10, 11];

  // Extract the ID from the current location pathname
  // const id = parseInt(location.pathname.split("/").pop(), 10);

  // Check if the ID falls within the packer or sand screen range
  //const isOpenPacker = packerIdRange.includes(id);
  //const isOpenSandScreen = sandScreenIdRange.includes(id);

  // Set the state based on the ID range
  //setOpenPacker(isOpenPacker);
  //setOpenSandScreen(isOpenSandScreen);
  // setOpenPacker(id >= 1 && id <= 8);

  //setOpenSandScreen(id >= 9 && id <= 11);
  // }, [location]);
  //console.log("in use effect",openPacker)
  // const handleClick = (item) => {
  //       if (item === "PerformancePacker") {
  //         setOpenPacker(true);
  //         setOpenSandScreen(false);
  //       } else if (item === "SandScreen") {
  //         setOpenSandScreen(true);
  //         setOpenPacker(false);
  //       }
  //     };
  useEffect(() => {
    // Extract the ID from the URL path
    const id = parseInt(location.pathname.split("/").pop(), 10);

    // Determine whether the Packer section should be open based on the ID
    const isPackerOpen = (id >= 1 && id <= 8) || id === 100;

    // Determine whether the Sand Screen section should be open based on the ID
    const isSandScreenOpen = (id >= 9 && id <= 11) || id === 101;

    // Update the state to reflect the calculated values
    setOpenPacker(isPackerOpen);
    setOpenSandScreen(isSandScreenOpen);
  }, [location]);

  // const handlePackerClick = () => {
  //   //event.preventDefault(); // Prevent default navigation behavior
  //   //setOpenPacker(!openPacker);
  //   console.log("Before clicking - openPacker:", openPacker);
  // console.log("Before clicking - openSandScreen:", openSandScreen);
  //   setOpenPacker((prevOpen) => !prevOpen); // Toggle the open state immediately
  //   setOpenSandScreen(false);
  //   navigate("/tool/packer");

  //   console.log("After clicking - openPacker:", !openPacker);
  //   console.log("After clicking - openSandScreen:", openSandScreen);
  // };

  // const handleSandScreenClick = (event) => {
  //   event.preventDefault(); // Prevent default navigation behavior
  //   setOpenSandScreen(!openSandScreen);
  //   setOpenPacker(false);
  // };
  return (
    <Box sx={{ display: "flex" }}>
      <List
        sx={{
          maxWidth: "100%",
          width: { sm: "250px", md: "250px" },
          bgcolor: "background.paper",
           paddingTop: 0,
        }}
        component="nav"
        aria-labelledby="nested-list-subheader"
      >
        <ListItem
          component={Link}
          to="/tool/100"
          // onClick={() => handleClick("PerformancePacker")}
          // onClick={() => setOpenPacker(!openPacker)}
          className={openPacker ? "active" : ""}

          // onClick={(e) => {
          //   e.preventDefault();
          //   setOpenPacker(!openPacker);
          //   setOpenSandScreen(false);
          // }}

          // onClick={() => {
          //   setOpenPacker(!openPacker);
          //   setOpenSandScreen(false);
          // }}
          // component={ButtonBase}
          // onClick={handlePackerClick}
        >
          <ListItemText primary="High Performance Packer" />
          {openPacker ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={openPacker} timeout="auto" unmountOnExit>
          <ListItem
            component={Link}
            to="/tool/3"
            sx={{ pl: 4 }}
            // className={
            //   location.pathname.includes("/tool/details/3") ? "active" : ""
            // }
            // className={`${location.pathname === "/tool/3" || openPacker ? "active" : ""}`}

            className={
              location.pathname.includes("/tool/details/3") ||
              location.pathname === "/tool/3" // Add condition for direct match
                ? "active"
                : ""
            }
          >
            <ListItemText primary="Swellable Packer" />
          </ListItem>
          <ListItem
            component={Link}
            to="/tool/2"
            sx={{ pl: 4 }}
            // className={
            //   location.pathname.includes("/tool/details/2") ? "active" : ""
            // }
            className={
              location.pathname.includes("/tool/details/2") ||
              location.pathname === "/tool/2" // Add condition for direct match
                ? "active"
                : ""
            }
          >
            <ListItemText primary="HR Packer" />
          </ListItem>
          <ListItem
            component={Link}
            to="/tool/1"
            sx={{ pl: 4 }}
            className={
              location.pathname.includes("/tool/details/1") ||
              location.pathname === "/tool/1" // Add condition for direct match
                ? "active"
                : ""
            }
          >
            <ListItemText primary="IP Isolation Packer" />
          </ListItem>
        </Collapse>

        <ListItem
          component={Link}
          to="/tool/101"
          //onClick={() => handleClick("SandScreen")}
          // onClick={() => setOpenSandScreen(!openSandScreen)}
          className={openSandScreen ? "active" : ""}

          // onClick={(e) => {
          //   e.preventDefault();
          //   setOpenSandScreen(!openSandScreen);
          //   setOpenPacker(false);
          // }}

          //onClick={handleSandScreenClick}
        >
          <ListItemText primary="High quality sand control screen" />
          {openSandScreen ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={openSandScreen} timeout="auto" unmountOnExit>
          <ListItem
            component={Link}
            to="/tool/9"
            sx={{ pl: 4 }}
            // className={
            //   location.pathname.includes("/tool/details/9") ? "active" : ""
            // }
            className={
              location.pathname.includes("/tool/details/9") ||
              location.pathname === "/tool/9" // Add condition for direct match
                ? "active"
                : ""
            }
          >
            <ListItemText primary="JM Premium Screen" />
          </ListItem>
        </Collapse>
      </List>
    </Box>
  );
}
